import React, { useEffect, useState } from 'react';
import type { PlayerContactProps, PlayerFollowerProps, PublicPlayerProps } from '../../types';
import { useContacts } from '../../SocialComponents';
import { useColors } from '../../constants/useColors';
import { SocialComponentApi } from '../../SocialComponents/api';
import { PlayerRecommenderApi } from '../api';
import { ActivityIndicator, FlatList, Image } from 'react-native';
import { Button, Text, View } from '../../Components/Themed';
import PlayerFollowButton from '../../SocialComponents/PlayerFollowButton';
import { Checkbox, Icons, Toggle } from '../../Components';
import SearchBox from '../../Components/SearchBox';
import Pagination from '../../Components/Pagination';


type ContactsSelectorProps = {
    player_id?:string,
    referral_code?:string,
    onInviteContacts: (pc:PlayerContactProps[]) => void,
    onSelectContact:(pc:PlayerContactProps, p?:PublicPlayerProps) => void,
}
const sections = ['toggle', 'selected', 'search', 'pagination', 'contacts','players']
const ContactsSelector = ({ player_id, referral_code, onSelectContact, onInviteContacts }:ContactsSelectorProps) => {
    const Colors = useColors();
    const { is_available, permission, compareContacts } = useContacts({ referral_code });
    const [ selected_contacts, setSelectedContacts ] = useState<PlayerContactProps[]>([]);
    const [ contacts, setContacts ] = useState<{
        loading:boolean,
        checked:boolean
    }>({
        loading:false,
        checked: false
    });
    const [ search, setSearch ] = useState('');
    const [ contact_data, setContactData ] = useState<{
        contacts_loading:boolean,
        active_toggle:string,
        player_contacts:PlayerContactProps[],
        players:PublicPlayerProps[],
        player_followers:PlayerFollowerProps[]
    }>({
        contacts_loading: false,
        active_toggle:'inactive',
        player_contacts: [],
        players: [],
        player_followers:[]
    });
    const [ offset, setOffset ] = useState(0);
    const { contacts_loading, players, player_followers, player_contacts, active_toggle } = contact_data
    let converted = player_contacts.filter(pc => pc.sub_type == 'phone' && pc.connected_player_id);
    let pending = player_contacts.filter(pc => pc.sub_type == 'phone' && !pc.connected_player_id)
    let visible_converted = converted.slice(offset * 20, (offset*20) + 20);
    let visible_pending = pending.slice(offset * 20, (offset*20) + 20);
    if(search){
        visible_converted = converted.filter(c => `${c.first_name} ${c.last_name}`.toLowerCase().includes(search.toLowerCase())).slice(offset * 20, (offset*20) + 20);
        visible_pending = pending.filter(c => `${c.first_name} ${c.last_name}`.toLowerCase().includes(search.toLowerCase())).slice(offset * 20, (offset*20) + 20);
    }


    useEffect(() => {
        SocialComponentApi.setEnvironment();
        PlayerRecommenderApi.setEnvironment();
        if(!player_id){ return }
        if(!is_available){ return }
        if(!permission?.granted){ return }
        if(contacts.checked){ return }
        checkContacts();
    },[player_id, permission?.granted, is_available])

    const checkContacts = async() => {
        if(contacts.checked){ return }
        if(!player_id){ return }
        setContactData({ ...contact_data, contacts_loading:true });
        const pcs = await compareContacts(player_id);
        const player_ids = [ ...new Set(pcs.map(c => c.connected_player_id ?? '0')) ]
        const ps = await SocialComponentApi.getPlayersByIds(player_ids);
        let pfs = await PlayerRecommenderApi.getBulkPlayerfollowers(ps.map(p => p.player_id));
        setContacts({ loading:false, checked:true })
        setContactData({
            ...contact_data,
            contacts_loading: false,
            players: ps,
            player_followers: pfs,
            player_contacts: pcs
        });
    }

    const renderContacts = (data:{ item:PlayerContactProps, index:number }) => {
        const pf = player_followers.find(pf => pf.following_id == data.item.connected_player_id);
        const player = players.find(p => p.player_id == data.item.connected_player_id);
        const selected = selected_contacts.find(c => c.player_contact_id  == data.item.player_contact_id) ? true : false
        return (
            <Button 
                key={data.item.player_contact_id.toString()} 
                float 
                style={{ padding:0, margin:4 }} 
                onPress={() => {
                    if(player){ return onSelectContact(data.item, player) }
                    if(selected){
                        return setSelectedContacts(selected_contacts.filter(c => c.player_contact_id != data.item.player_contact_id))
                    }
                    return setSelectedContacts(selected_contacts.concat(data.item))
                }}
                >
                <Image
                    source={{ uri: player?.profile_pic &&  player?.profile_pic != '' ?  player?.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                    style={{ height:75, width:115, borderTopRightRadius:8, borderTopLeftRadius:8 }}
                    resizeMode='cover'
                />
                <View style={{ flexGrow:1, padding:5}}>
                    <Text theme='h2' textAlign='center' style={{ maxWidth:100 }}>{data.item.first_name} {data.item.last_name}</Text>
                    {player?
                    <Text theme='description' textAlign='center' style={{ maxWidth:100 }}>@{player.username}</Text>
                    :<></>}
                </View>
                <View transparent style={{ padding:5, borderTopWidth:1, borderColor:Colors.borders.light }}>
                    {player ?
                    <PlayerFollowButton
                        player_id={player.player_id}
                        following={pf}
                        //follower={pf}
                        onFollowingUpdate={(new_pf) => {
                            setContactData({ 
                                ...contact_data, 
                                player_followers: player_followers.filter(pf => pf.player_follower_id != new_pf.player_follower_id).concat(new_pf)
                            })
                        }}
                    />
                    :
                    <Button
                        transparent
                        style={{ padding:10, flexDirection:'row', alignItems:'center' }}
                        onPress={() => {
                            if(selected){
                                return setSelectedContacts(selected_contacts.filter(c => c.player_contact_id != data.item.player_contact_id))
                            }
                            return setSelectedContacts(selected_contacts.concat(data.item))
                        }}
                    >
                        <Checkbox size={14} color={Colors.text.action} checked={selected} disabled onSelect={() => console.log('')}/>
                        <Text theme='action' style={{ marginLeft:10 }}>Select</Text>
                    </Button>
                    }
                </View>
            </Button>  
        )
    }

    const renderSections = (data:{ item:string, index:number }) => {
        switch(data.item){
            case 'toggle':
                return (
                    <View style={{ padding:10 }}>
                        <Toggle
                            options={[
                                { key: 'active', label: 'Joined' },
                                { key: 'inactive', label: 'Not Joined' }
                            ]}
                            selected_option={active_toggle}
                            onSelectOption={(key) => {
                                setContactData({ ...contact_data, active_toggle: key });
                                setOffset(0)
                            }}
                        />
                    </View>
                )
            case 'search':
                return (
                    <View style={{ padding:10, paddingTop:0 }}>
                        <SearchBox
                            hide_search_button
                            onChange={(text) => {
                                if(offset != 0){ setOffset(0) }
                                setSearch(text)
                            }}
                        />                        
                    </View>
                )
            case 'selected':
                if(selected_contacts.length == 0){ return <></> }
                if(active_toggle == 'active'){ return <></> }
                return (
                    <View>
                        <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10 }}>
                            <View transparent style={{ flex:1 }}>
                                <Text theme='h1'>Selected Contacts</Text>
                                <Text style={{ marginTop:3 }}>Send these contacts an invite!</Text>
                            </View>
                            <View transparent style={{ marginLeft:10, marginRight:10 }}>
                                <Text theme='h1' color={Colors.text.action}>{selected_contacts.length}</Text>
                            </View>
                            <Button
                                title='X'
                                transparent
                                title_color={Colors.text.error}
                                style={{ marginRight:10 }}
                                onPress={() => setSelectedContacts([])}
                            />
                            <Button
                                title='Invite'
                                type='success'
                                onPress={() => onInviteContacts(selected_contacts)}
                            />
                        </View>
                        <View style={{ padding:10 }}>
                            <FlatList
                                data={selected_contacts}
                                renderItem={renderContacts}
                                keyExtractor={(item) => item.player_contact_id.toString()}
                                horizontal
                                key={'selected_list'}
                            />
                        </View>
                    </View>
                )
            case 'pagination':
                return (
                    <Pagination
                        offset={offset}
                        onNext={() => setOffset(offset + 1)}
                        onPrevious={() => setOffset(offset - 1)}
                    />
                )
            case 'contacts':
                if(active_toggle != 'inactive'){ return <></> }
                return (
                    <View style={{ flexDirection:'row', justifyContent:'center', flexWrap:'wrap' }}>
                        {visible_pending.map((item, index) => {
                            return renderContacts({ item, index })
                        })}
                    </View>
                )
            case 'players':
                if(active_toggle != 'active'){ return <></> }
                return (
                    <View style={{ flexDirection:'row', justifyContent:'center', flexWrap:'wrap' }}>
                        {visible_converted.map((item, index) => {
                            return renderContacts({ item, index })
                        })}
                    </View>
                )
            default: return <></>
        }
    }

    if(!permission?.granted){ return <></> }
    return (
        <View style={{ flex:1 }}>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:15 }}>
                <Icons.ContactsIcon color={Colors.text.h1} size={26} />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>Your Contacts</Text>
                    <Text theme='description' style={{ marginTop:3 }}>Challenge your friends! Earn some free $$ when they sign up with your code and deposit!</Text>
                </View>
            </View>
            <View style={{ flex:1 }}>
                <FlatList
                    data={sections}
                    windowSize={2}
                    key={'contacts_section'}
                    renderItem={renderSections}
                />
            </View>
            <View style={{ padding:10, flexDirection:'row' }}>
                {contacts_loading ?
                <ActivityIndicator
                    style={{ padding:10, alignSelf:'center' }}
                    color={Colors.text.h1}
                    size={'large'}
                />
                :<></>}
                
            </View>
        </View>
    )
}

export default ContactsSelector